export default "data:video/mp2t;base64,aW1wb3J0IFByb21wdExpc3REYXRhIGZyb20gJy4vYWxsJwoKZXhwb3J0IGRlZmF1bHQgUHJvbXB0TGlzdERhdGE="